import { type TMenuConfig } from '@/components/menu';

export const MENU_SIDEBAR: TMenuConfig = [
  {
    title: 'Dashboards',
    icon: 'chart-simple-2',
    path: '/',
  },
  {
    title: 'Roles & Permissions',
    icon: 'shield-tick',
    path: '/roles-management',
  },
  {
    title: 'Subscription Management',
    icon: 'wallet',
    children: [
      {
        title: 'Subscription Management',
        path: '/subscription-management',
      },
      {
        title: 'Historical Growth Trends',
        path: '/historical-trends',
      },
      {
        title: 'Cancellation Reports',
        path: '/cancellation-reports',
      },
      {
        title: 'Revenue Report',
        path: '/revenue-report',
      },
    ],
  },
  {
    title: 'User Management',
    icon: 'users',
    path: '/user-management',
  },

  {
    title: 'Organization Management',
    icon: 'element-2',
    path: '/organization-management',
  },
  {
    title: 'Boat Management',
    icon: 'ship',
    path: '/boat-management',
  },
  {
    title: 'Harbor Management',
    icon: 'logistic',
    path: '/habor-management',
  },
  {
    title: 'Community Management',
    icon: 'people',
    path: '/community-management',
  },
  {
    title: 'DMO Management',
    icon: 'geolocation',
    path: '/dmo-management',
  },
  {
    title: 'Promo Management',
    icon: 'discount',
    children: [
      {
        title: 'Promo Management',
        path: '/promo-management',
      },
      {
        title: 'Discount Tracking Reports',
        path: '/discount-tracking-reports',
      },
    ],
  },
  {
    title: 'Region',
    icon: 'geolocation',
    path: '/region-management',
  },
  {
    title: 'Yacht Clubs',
    icon: 'bank',
    path: '/club-management',
  },
  {
    title: 'User Feedbacks/Reviews',
    icon: 'message-text-2',
    path: '/user-feedbacks',
  },
  {
    title: 'Settlements',
    icon: 'receipt-square',
    path: '/settlements',
  },
  {
    title: 'Transactions',
    icon: 'lts',
    path: '/transactions',
  },
  {
    title: 'Subscription Transactions',
    icon: 'bill',
    path: '/subscription-transactions',
  },
  {
    title: 'Helpdesk FAQ',
    icon: 'support',
    path: '/helpdesk-faq',
  },
  {
    title: 'Audit Logs',
    icon: 'abstract-14',
    children: [
      {
        title: 'User Logs',
        path: '/user-logs',
      },
      {
        title: 'Export Report Logs',
        path: '/export-logs',
      },
      {
        title: 'Delete Logs',
        path: '/delete-logs',
      },
    ],
  },
  {
    title: 'CMS',
    icon: 'setting',
    children: [
      {
        title: 'About US',
        path: '/about-us',
      },
      {
        title: 'Legal compliance',
        path: '/legal-compliance',
      },
      {
        title: 'Terms & Conditions',
        path: '/terms-and-conditions',
      },
      {
        title: 'Privacy Policy',
        path: '/privacy-policy',
      },
      {
        title: 'Accessibility',
        path: '/accessibility',
      },
      {
        title: 'Licensing & Data Sources',
        path: '/licensing',
      },
      {
        title: 'FAQ',
        path: '/faq',
      },
      {
        title: 'Cookie Consent Settings',
        path: '/cookie-consent-settings',
      },
      {
        title: 'Testimonials',
        path: '/testimonial-management',
      },
      {
        title: 'Email Template Management',
        path: '/email-template-management',
      },
      {
        title: 'Template Layout Management',
        path: '/template-layout-management',
      },
      {
        title: 'Notification Template Management',
        path: '/notification-template-management',
      },
    ],
  },
  {
    title: 'Configuration',
    icon: 'setting-2',
    children: [
      {
        title: 'Booking Reminder Configuration',
        path: '/booking-reminder-configuration',
      },
      {
        title: 'Guest Visibility',
        path: '/configuration/guest-visibility',
      },
      {
        title: 'Guest Booking Governance',
        path: '/configuration/guest-booking-governance',
      },
      {
        title: 'Product VAT Config',
        path: '/product-vat-config',
      },
      {
        title: 'Domestic VAT Config',
        path: '/domestic-vat-config',
      },
      {
        title: 'Business Entity VAT Config',
        path: '/business-entity-vat-config',
      },
      {
        title: 'Penalty Configuration',
        path: '/penalty-config',
      },
      {
        title: 'PSP Fee Configuration',
        path: '/psp-fee-config',
      },
      {
        title: 'Commission Policy',
        path: '/configuration/commission',
      },
      {
        title: 'Subscription Trial Config',
        path: '/configuration/subscription-trial',
      },
      {
        title: 'Entitlement Grants',
        path: '/configuration/entitlement-grants',
      },
      {
        title: 'Environment Variables',
        path: '/configuration/environment-variables',
      },
    ],
  },
  {
    title: 'External Services',
    icon: 'technology-4',
    path: '/external-services',
  },
  ...(import.meta.env.VITE_ENV === 'staging'
    ? [
        {
          title: 'Routing Management',
          icon: 'route',
          children: [
            {
              title: 'Routing Management',
              path: '/routing-management',
            },
            {
              title: 'Routing Debugger',
              path: '/routing-management/debugger',
            },
          ],
        },
      ]
    : [
        {
          title: 'Routing Management',
          icon: 'route',
          path: '/routing-management',
        },
      ]),
  {
    title: 'Theme Routes',
    icon: 'route',
    path: '/theme-routes',
  },
  {
    title: 'Icons Management',
    icon: 'abstract-24',
    path: '/icons-management',
  },
  {
    title: 'KPI Management',
    icon: 'chart-simple-2',
    path: '/kpi-management',
  },
  {
    title: 'Deployements',
    icon: 'electricity',
    path: '/deployements',
  },
  {
    title: 'Service Provider Management',
    icon: 'delivery-2',
    path: '/service-management',
  },

  {
    title: 'Article Management',
    icon: 'document',
    path: '/article-management',
  },
  {
    title: 'Service Moderation',
    icon: 'shield-search',
    path: '/service-moderation',
  },
  {
    title: 'Advertise Management',
    icon: 'euro',
    path: '/advertise-management',
  },
  {
    title: 'System Announcements',
    icon: 'notification-bing',
    path: '/system-announcements',
  },
  {
    title: 'KYC Management',
    icon: 'shield-tick',
    path: '/kyc-management',
  },
  {
    title: 'Notification Preferences',
    icon: 'setting-3',
    path: '/notification-preferences',
  },
  {
    title: 'Platform Settings',
    icon: 'setting-4',
    path: '/platform-setting',
  },
  {
    title: 'List Value Management',
    icon: 'abstract-26',
    path: '/list-value-management',
  },
  {
    title: 'Accounting Exports',
    icon: 'wallet',
    path: '/netvisor/accounting-exports',
  },
];

export const MENU_MEGA: TMenuConfig = [
  {
    title: 'Home',
    path: '/',
  },
];

export const MENU_ROOT: TMenuConfig = [
  {
    title: 'Public Profile',
    icon: 'profile-circle',
    rootPath: '/public-profile/',
    path: 'public-profile/profiles/default',
    childrenIndex: 2,
  },
  {
    title: 'Account',
    icon: 'setting-2',
    rootPath: '/account/',
    path: '/',
    childrenIndex: 3,
  },
  {
    title: 'Network',
    icon: 'users',
    rootPath: '/network/',
    path: 'network/get-started',
    childrenIndex: 4,
  },
  {
    title: 'Authentication',
    icon: 'security-user',
    rootPath: '/authentication/',
    path: 'authentication/get-started',
    childrenIndex: 5,
  },
];
